export enum Language {
  ENGLISH = 'en',
  SPANISH = 'es',
  PORTUGUESE = 'pt',
  TURKISH = 'tr',
  THAI = 'th',
}

export const GAME_RULES_SUPPORTED_LANGUAGES = [
  Language.ENGLISH,
  Language.SPANISH,
  Language.PORTUGUESE,
  Language.TURKISH,
];



// WEBPACK FOOTER //
// ./ts/app/shared/types/language.ts